<script setup lang="ts">
  import { computed } from "vue";
  import { COMPLETION_COLORS } from "@/lib/chartPalettes";
  import { percent, type CompletionSummary } from "./completionMetrics";
  import { formatCount as count } from "@/utils/formatters";

  const props = defineProps<{ summary: CompletionSummary }>();

  const kpis = computed(() => [
    {
      label: "Starts",
      value: count(props.summary.n_started),
      caption: "Respondents who opened the survey",
      dot: null,
    },
    {
      label: "Overall completion",
      value: percent(props.summary.overall_completion * 100),
      caption: `${count(props.summary.n_complete)} completes / ${count(props.summary.n_started)} starts`,
      dot: null,
    },
    {
      label: "Net completion",
      value: percent(props.summary.net_completion * 100),
      caption: "Est. completion rate if nobody were screened out",
      dot: COMPLETION_COLORS.drop,
    },
    {
      label: "Net screenout",
      value: percent(props.summary.net_screenout * 100),
      caption: "Est. screen out rate if nobody dropped",
      dot: COMPLETION_COLORS.screenout,
    },
  ]);
</script>

<template>
  <div class="grid grid-cols-4 divide-x divide-border rounded-lg border">
    <div
      v-for="kpi in kpis"
      :key="kpi.label"
      class="flex flex-col gap-1 px-5 py-4">
      <span class="heading-label flex items-center gap-1.5">
        <span
          v-if="kpi.dot"
          class="size-2 rounded-full"
          :style="{ backgroundColor: kpi.dot }" />
        {{ kpi.label }}
      </span>
      <span class="heading-display tabular-nums">{{ kpi.value }}</span>
      <span class="text-xs text-foreground-subtle">{{ kpi.caption }}</span>
    </div>
  </div>
</template>
